export const authAppCodeMap = {
  'hongtutu-order': [
    'TEA_SHEET_AUDIT',
    'SETTING_TEA_FEE_ALLOT',
    'TEA_SHEET_SCH_AUDIT',
    'REFUND_SUBMIT',
    'REFUND_AUDIT',
    'REFUND_CANCEL',
    'BATCH_REFUND_SUBMIT',
    'BATCH_REFUND_AUDIT',
    'BATCH_REFUND_CANCEL',
    'SETTING_DIVIDE_RULE',
    'CONFIRM_SETTLEMENT',
    'SETTLE_AUDIT_SETTING',
    // 'LEAVE_REFUND_BATCH_CHECK',
    'LEAVE_REFUND_BATCH_CHECK_ADMIN', // 请假可退款批量审批(运营端)
    'LEAVE_REFUND_BATCH_CHECK_SCH', // 请假可退款批量审批(学校端)
    // 'MANUAL_PROCESSING_REFUND'
    'MANUAL_PROCESSING_REFUND_ADMIN', // 退款失败处理(运营端)
    'MANUAL_PROCESSING_REFUND_SCH', // 退款失败处理(学校端)

    'START_CLASS_FAIL_REFUND_ADMIN', // 开班失败发起退款(运营端)
    'START_CLASS_FAIL_REFUND_SCH', // 开班失败发起退款(学校端)
    'COUPON_MANAGEMENT',
    'IMPORT_ORDER', // 导入订单
    'ACADEMIC_AFFAIRS_CONFIRMATION', // 教务确认
    'PAYEE_CONFIRMATION', // 收款方确认
    'PROVIDER_CONFIRMATION', // 提供方确认
    'EDU_CONFIRMATION' // 教育局确认
  ],
  'hongtutu-basic': [
    'CLOSE_OPEN_SYS_NOTION',
    '430_SYS_YEAR_TERM',
    'SET_AUTO_REFUND'
  ],
  'hongtutu-course': [
    'HANGING_COURSE_TYPE',
    'INTERNAL_MANAGEMENT'
  ]
};

// 权限和对应的权限集编码
// 运营端：
// 教师考勤确认财务审批：TEA_SHEET_AUDIT
// 分账规则配置：SETTING_DIVIDE_RULE
// 开启/禁用系统通知：CLOSE_OPEN_SYS_NOTION
// 配置教师课酬梯度设置：SETTING_TEA_FEE_ALLOT
// 添加年度学期 430_SYS_YEAR_TERM

// 学校端：
// 教师考勤确认学校审批：TEA_SHEET_SCH_AUDIT

// appCode                         permissionSet

// hongtutu-order                TEA_SHEET_AUDIT
// hongtutu-order                SETTING_DIVIDE_RULE
// hongtutu-basic                CLOSE_OPEN_SYS_NOTION
// hongtutu-order                SETTING_TEA_FEE_ALLOT
// hongtutu-order                TEA_SHEET_SCH_AUDIT

// 新增：
// hongtutu-order

// 退款发起        REFUND_SUBMIT
// 退款审批        REFUND_AUDIT
// 退款撤销        REFUND_CANCEL
// 批量退款发起 BATCH_REFUND_SUBMIT
// 批量退款审批 BATCH_REFUND_AUDIT
// 批量退款撤销 BATCH_REFUND_CANCEL
// 退款失败处理 MANUAL_PROCESSING_REFUND
